import {
  auth,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  onAuthStateChanged,
  RecaptchaVerifier,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPhoneNumber,
  signInWithPopup,
  updateProfile,
} from "./firebaseApi";
import { logUserActivity } from "./activityService";

export function subscribeAuthState(onNext, onError) {
  return onAuthStateChanged(auth, onNext, onError);
}

export function signInWithEmail(email, password) {
  return signInWithEmailAndPassword(auth, email, password).then(async (cred) => {
    await logUserActivity(cred?.user?.uid, {
      type: "auth_login",
      title: "Logged in with email",
      details: "Signed in to Smart Farming account.",
    });
    return cred;
  });
}

export function sendResetEmail(email) {
  return sendPasswordResetEmail(auth, email);
}

export function signInWithGoogle() {
  return signInWithPopup(auth, new GoogleAuthProvider()).then(async (cred) => {
    await logUserActivity(cred?.user?.uid, {
      type: "auth_login_google",
      title: "Logged in with Google",
      details: "Signed in using Google account.",
    });
    return cred;
  });
}

export function createEmailAccount(email, password) {
  return createUserWithEmailAndPassword(auth, email, password).then(async (cred) => {
    await logUserActivity(cred?.user?.uid, {
      type: "auth_signup",
      title: "Created account",
      details: "Signed up using email/password.",
    });
    return cred;
  });
}

export function updateAuthDisplayName(user, displayName) {
  return updateProfile(user, { displayName });
}

export function getOrCreateInvisibleRecaptcha(containerId, cacheKey) {
  if (window[cacheKey]) return window[cacheKey];
  const verifier = new RecaptchaVerifier(auth, containerId, { size: "invisible" });
  window[cacheKey] = verifier;
  return verifier;
}

export function requestPhoneOtp(phoneE164, verifier) {
  return signInWithPhoneNumber(auth, phoneE164, verifier);
}

